import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Suspense, lazy } from "react";
import "react-toastify/dist/ReactToastify.css";
import { pageName } from "./utils/pagesUtil";
import { user } from "./utils/user";
import { ToastContainer } from "react-toastify";
import Contact from "./pages/Contact";

const NominateOthers = lazy(() => import("./pages/NominateOthers"));
const DifferentUsers = lazy(() => import("./pages/DifferentUsers"));
const DetailsPage = lazy(() => import("./pages/detailsPage"));
const LoginPage = lazy(() => import("./pages/auth/LoginPage"));
const SignupPage = lazy(() => import("./pages/auth/SignupPage"));
const ViewStudents = lazy(() => import("./pages/viewStudents"));
const NmcPage = lazy(() => import("./pages/nmc_page"));
const VerificationPage = lazy(() => import("./pages/VerificationPage"));
const PasswordResetRequest = lazy(() => import("./pages/PasswordResetRequest"));
const PasswordReset = lazy(() => import("./pages/PasswordReset"));
const PasswordResetProfile = lazy(() => import("./pages/PasswordResetProfile"));
const PasswordResetProfileAlumni = lazy(() =>
  import("./pages/PasswordResetProfileAlumni")
);

const Loader = () => (
  <div className="h-100vh w-100vw flex align-center justify-center">
    <div className="waterfall">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
);

function App() {
  return (
    <>
      <Suspense fallback={<Loader />}>
        <Router>
          <Routes>
            <Route exact path="/" element={<DifferentUsers />} />
            <Route
              exact
              path="/login"
              element={<LoginPage user={user} isFaculty={false} />}
            />
            <Route exact path="/nominate" element={<NominateOthers />} />
            <Route exact path="/contact" element={<Contact />} />
            <Route
              exact
              path="/staff"
              element={<LoginPage user={user} isFaculty={true} />}
            />
            <Route
              exact
              path="/nmc"
              element={<LoginPage user={user} isNmc={true} />}
            />
            <Route path="/nmc-page" element={<NmcPage />} />
            <Route path="/signup" element={<SignupPage user={user} />} />
            <Route path="/reset-password" element={<PasswordResetRequest />} />
            <Route
              path="/reset-password/:type/:id/:token"
              element={<PasswordReset />}
            />
            <Route
              path="/reset-password-profile"
              element={<PasswordResetProfile />}
            />
            <Route
              path="/reset-password-profile-alumni"
              element={<PasswordResetProfileAlumni />}
            />
            <Route path={pageName[ 1 ]} element={<DetailsPage step={1} />} />
            <Route path={pageName[ 2 ]} element={<DetailsPage step={2} />} />
            <Route path={pageName[ 3 ]} element={<DetailsPage step={3} />} />
            <Route path={pageName[ 4 ]} element={<DetailsPage step={4} />} />
            <Route path={pageName[ 5 ]} element={<DetailsPage step={5} />} />
            <Route
              path="/view-applicants"
              element={<ViewStudents user={user} />}
            />
            <Route
              path="/verify/:type/:id/:token"
              element={<VerificationPage />}
            />
          </Routes>
        </Router>
      </Suspense>
      <ToastContainer
        position="top-right"
        autoClose={2500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </>
  );
}

export default App;
